// Centralise ici tous les liens externes du site Vitrine The Mimi Factory.
// Modifiez ces valeurs pour pointer vers vos vrais comptes / annonces.

export const AVATAR_URL = 'https://static.lumi.new/3b/3b8976ef1de0de649ccbfa2484318ab6.png'
export const LOGO_URL = 'https://static.lumi.new/3b/3b8976ef1de0de649ccbfa2484318ab6.png'

export const CONTACT_EMAIL = 'contact@themimifactory.com'
export const COLLAB_EMAIL = 'themimifactory@gmail.com'

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/themimifactory',
  tiktok: 'https://www.tiktok.com/@themimifactory',
  facebook: 'https://www.facebook.com/themimifactory',
  youtube: 'https://www.youtube.com/@themimifactory',
}

// Pages officielles du site themimifactory.com
export const AMENAGEMENT_CLE_EN_MAIN_URL = 'https://www.themimifactory.com/amenagement-cle-en-main'
export const MEUBLES_URL = 'https://www.themimifactory.com/meubles'
export const PACK_AMENAGEMENT_URL = 'https://www.themimifactory.com/pack-amenagement'

export const VANS_FOR_SALE_URL = 'https://www.themimifactory.com/vans'
export const VANS_FOR_RENT_URL = 'https://www.themimifactory.com/location'

export const TENTE_DE_TOIT_URL = 'https://www.themimifactory.com/tente-de-toit'
export const TENTE_DE_TOIT_IMAGE = 'https://static.lumi.new/material/8b/8b356ff1f616d9204e59dddd483150e1.webp'

export const NEWSLETTER_URL = 'https://l.instagram.com/?u=https%3A%2F%2Fgo.themimifactory.com%2F3833087b%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio%26fbclid%3DPAcGRvZgJleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA85MzY2MTk3NDMzOTI0NTkAAadFQ1_xMEJZBius7vEmmkvQo7Gr9aShauDlOKOuK1l01D8OHwoxmlSOXUT-rA_aem_BjkIZqTe2mnrlNSrhPSznQ&e=AUCfaPRIHTcs5SovCFjg1hdSZVcq0l0iBWhWf2mtzrs0pGucT6gXFV7zmj7oAyptHOCl1zvBaakYQIeLddVSDeFP8QCzVAU2Hi06uUs1k0cJUGmqrLqZt5lZEajCc3K-efrfX9WM5mCF'

export const APP_URL = 'https://app.themimifactory.com/'

// Ebooks / plans numeriques en vente
export interface EbookItem {
  id: string
  title: string
  caption: string
  language: 'FR' | 'EN'
  image: string
  buyUrl: string
}

export const EBOOKS: EbookItem[] = [
  {
    id: 'lit-peigne-fr',
    title: 'Plan complet lit peigne',
    caption: 'Plan détaillé et complet pour construire un lit peigne coulissant, une solution gain de place idéale pour votre van.',
    language: 'FR',
    image: 'https://static.lumi.new/material/61/61e913e19af905f22b4395b7c6abdd5d.jpeg',
    buyUrl: 'https://go.themimifactory.com/d0863251',
  },
  {
    id: 'sliding-bed-en',
    title: 'Sliding bed plan',
    caption: 'Detailed, complete plan to build a sliding comb bed, a great space-saving solution for your van.',
    language: 'EN',
    image: 'https://static.lumi.new/material/61/61e913e19af905f22b4395b7c6abdd5d.jpeg',
    buyUrl: 'https://go.themimifactory.com/d0863251-bbaa76c5',
  },
]
